<template>
  <div v-if="CURR_PLATFORM_TYPE_DETAIL" class="launchAppBtn" :class="{ tapActive: getIsApp }">
    <template v-if="getIsApp">
      <div :style="'border: 1px solid ' + CURR_PLATFORM_TYPE_DETAIL.themeColor" class="subCon" @click="btnHandler">
        <van-image class="icon" :src="CURR_PLATFORM_TYPE_DETAIL['iconImg']" />
        <div class="label" :style="'color:' + CURR_PLATFORM_TYPE_DETAIL.themeColor">{{ `${CURR_PLATFORM_TYPE_DETAIL['collectively']}APP` }}</div>
        <div class="iconfont icon-fenxiang_2" :style="'color:' + CURR_PLATFORM_TYPE_DETAIL.themeColor"></div>
      </div>
    </template>
    <template v-else>
      <div class="subCon">
        <van-image class="icon" :src="CURR_PLATFORM_TYPE_DETAIL['iconImg']" />
        <div class="label" :style="'color:' + CURR_PLATFORM_TYPE_DETAIL.themeColor">{{ `${CURR_PLATFORM_TYPE_DETAIL['collectively']}APP` }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import launchAppHandler from '@/mixins/launchAppHandler'
export default {
  mixins: [launchAppHandler],
  props: {
    soHoInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['getIsApp']),
    CURR_PLATFORM_TYPE_DETAIL() {
      if (this.soHoInfo) {
        const { PlatformType } = this.soHoInfo
        return this.PLATFORM_TYPE_DETAIL[PlatformType]
      }
      return null
    }
  },
  methods: {
    btnHandler() {
      const { SearchType, SearchKey, PlatformType } = this.soHoInfo
      this.launchAppHandler({ SearchType, SearchKey, PlatformType })
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.launchAppBtn {
  .subCon {
    display: flex;
    align-items: center;
    padding: vw(0) vw(8);
    height: vw(20);
    border-radius: vw(10);
    .icon {
      width: vw(14);
      height: vw(14);
      margin-right: vw(4);
    }
    .label {
    }
    .iconfont {
      margin-left: vw(4);
      font-size: vw(12);
    }
  }
}
</style>
